import BindingContext from "@odata/BindingContext";
import { PrTaxpayerDeclarationEntity } from "@odata/GeneratedEntityTypes";
import { LanguageCode, PrTaxDiscountTypeCode } from "@odata/GeneratedEnums";
import FileStorage from "@utils/FileStorage";
import saveAs from "file-saver";

import { REST_API_URL } from "../../../constants";
import { IAppContext } from "../../../contexts/appContext/AppContext.types";
import { IDeductionTypePaths } from "./TaxpayerDeclaration.types";

export const getTogglePropPath = (type: PrTaxDiscountTypeCode): string => {
    return `##Show${type}##`;
};

export const showChildrenPath = BindingContext.localContext(`Show${PrTaxpayerDeclarationEntity.Children}`);
export const isThereOtherProviderPath = "##isThereOtherProvider##";
export const hasDisabilityDiscount = "##hasDisabilityDiscount##";
export const disabilityDiscountType = "##disabilityDiscountType##";

export const getPathsForDeductionType = (type: PrTaxDiscountTypeCode): IDeductionTypePaths => {
    return {
        switchPath: getTogglePropPath(type)
    };
};

export async function massExportToPDF(ids: string[], context: IAppContext, languageCode = LanguageCode.Czech): Promise<void> {
    const queryIds = `taxpayerDeclarationIds=${ids.join("&taxpayerDeclarationIds=")}`;
    const pdfUrl = `${REST_API_URL}/PrTaxpayerDeclarationsPdfExport?languageCode=${languageCode}&${queryIds}&CompanyId=${context.getCompanyId()}`;

    const file = await FileStorage.get(null, {
        url: pdfUrl
    });

    saveAs(file);
}